import { render, staticRenderFns } from "./CreatePalletReceipt.vue?vue&type=template&id=6d069a94&scoped=true"
import script from "./CreatePalletReceipt.vue?vue&type=script&lang=js"
export * from "./CreatePalletReceipt.vue?vue&type=script&lang=js"
import style0 from "./CreatePalletReceipt.vue?vue&type=style&index=0&id=6d069a94&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d069a94",
  null
  
)

export default component.exports